<i
  class="spinner-border"
  [ngClass]="spinnerClasses"
  role="status"
  aria-hidden="true">
</i>

